import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { typeUser } from "./AdminLoginApi";

const initialState = {
  loading: false,
  user: {
    uuid: "",
    logo: "" as string | null,
    name: "",
    email: "",
    userOrganisations: [],
  } as typeUser,
  form: {
    usernameEmail: "",
    password: "",
  },
};

export const adminLoginSlice = createSlice({
  name: "adminLogin",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<typeof initialState.user>) => {
      state.user = action.payload;
    },
    setLoading: (state, action: PayloadAction<typeof initialState.loading>) => {
      state.loading = action.payload;
    },
    setForm: (state, action: PayloadAction<typeof initialState.form>) => {
      state.form = action.payload;
    },
    resetLogin: () => initialState,
  },
});

export const { setLoading, setForm, resetLogin, setUser } =
  adminLoginSlice.actions;

export default adminLoginSlice.reducer;
